module.exports = __webpack_public_path__ + "officialStatic/img/productB34.0ddbae0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/product/productB34.png
// module id = lsq3
// module chunks = 0